module.exports = __webpack_public_path__ + "static/media/assets.b97e0897.png";